import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Box,
  Grid2,
  Button,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import DashboardCards from './DashboardCards';
import Last24HoursChart from './Last24HoursChart';
import TimeTable from './HoursTable';
import CurrentStatusChart from './CurrentStatusChart';
import StatusSummaryBox from './CurrentStatusTable';
import Next24HoursChart from './Next24HoursChart';
import GameVideoEstimatesChart from './GameVideoEstimatesChart';
import HttpService from '../../hooks/Https-services';
import PAGE_ROUTES, {
  API_ROUTES,
  hasRole,
  ROLE_IDS,
} from '../../utils/constant';
import StaffingDashboardCards from './StaffingDashboardCards';
import LeaderShipTable from './LeaderShipTable';
import ModeratorScheduleTable from './ModeratorScheduleTable';
import TageerScheduleTable from './TageerScheduleTable';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import UserIdleChart from './UserIdleChart';
import TeamHoursChart from './TeamHoursChart';
import useCommonDetails from '../../hooks/useCommonDetails';

import ModeratorGameCountTable from './ModeratorGameCountTable';

import Games from './Games';
import ProductionTabs from './ProductionTabs';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      sx={{ p: 3 }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

function AdminDashboard() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const currentUserInfo = useCommonDetails();
  const isSuperAdmin = searchParams.get('isSuperAdmin') === 'true';
  const [loading, setLoading] = React.useState(false);
  const path = location.pathname;
  const urlPart = path.split('-')[1];

  const [tabIndex, setTabIndex] = useState(
    urlPart === 'production' ? 0 : urlPart === 'staffing' ? 1 : 2
  );

  const handleTabChange = (event: any, newValue: any) => {
    setTabIndex(newValue);
    if (newValue === 0) {
      navigate(PAGE_ROUTES.ADMINPRODUCTION);
    } else if (newValue === 1) {
      navigate(PAGE_ROUTES.ADMINSTAFFING);
    } else if (newValue === 2) {
      navigate(PAGE_ROUTES.ADMINGAMES);
    }
  };

  // const [currentStatusChartData, setCurrentStatusChartData] = useState<any>([]);
  // const getChartData = async () => {
  //   try {
  //     const response = await HttpService.get(API_ROUTES.countChartData);
  //     const apiData = response.data.data;
  //     setCurrentStatusChartData(apiData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   getChartData();
  // }, []);

  // const [hourChartData, setHourChartData] = useState<any>([]);

  // // Fetch the chart data from API
  // const getHoursChartData = async () => {
  //   try {
  //     const response = await HttpService.get(API_ROUTES.chartData);
  //     setHourChartData(response.data.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   getHoursChartData(); // Fetch the data on component mount
  // }, []);

  return (
    <Box>
      {/* Tabs for switching between "Production" and "Staffing" */}
      {hasRole(currentUserInfo.roleId, [ROLE_IDS.MODERATOR]) ? (
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="Dashboard Tabs"
        >
          <Tab label="Production" />
        </Tabs>
      ) : (
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="Dashboard Tabs"
        >
          <Tab label="Production" />
          <Tab label="Staffing" />
          <Tab label="Games" />
        </Tabs>
      )}

      {/* Tab Panel for "Production" */}
      <TabPanel value={tabIndex} index={0}>
        <ProductionTabs />
        {/* <Grid container spacing={2}>
          
          <Grid item xs={12} md={6}>
            <Grid item xs={12}>
              <DashboardCards />
            </Grid>

           
            <Card sx={{ margin: '20px 0' }}>
              <CardContent>
                <Typography variant="h6">Last 24 Hours</Typography>
                <Grid item xs={12} container>
                  <Grid item xs={12} md={12}>
                    <TimeTable apiData={hourChartData} />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Last24HoursChart apiData={hourChartData} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6">Current Status</Typography>
                <Grid item xs={12} container>
                  <Grid item xs={12} md={4}>
                    <StatusSummaryBox
                      statusChartData={currentStatusChartData}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <CurrentStatusChart
                      statusChartData={currentStatusChartData}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Grid item xs={12}>
              <GameVideoEstimatesChart />
            </Grid>
          </Grid>
        </Grid> */}
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <Grid container spacing={1}>
          {/* Top Cards */}
          <Grid item xs={12} md={6}>
            <Grid item xs={12} md={12}>
              <StaffingDashboardCards />
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid item xs={12} md={12}>
              <Typography variant="h6" fontWeight={600}>
                LEADERSHIP
              </Typography>
              <LeaderShipTable />
            </Grid>
          </Grid>
          {hasRole(currentUserInfo.roleId, [
            ROLE_IDS.ADMIN,
            ROLE_IDS.SUPER_ADMIN,
          ]) &&
            currentUserInfo.teamId === 3 && (
              <Grid item xs={12} md={6}>
                <Grid item xs={12} md={12}>
                  <ModeratorGameCountTable />
                </Grid>
              </Grid>
            )}

          {/* <Grid item xs={12} md={12}>
            <Card sx={{ margin: '20px 0' }}>
              <CardContent>
                <Typography variant="h6">Next 24 Hours</Typography>
                <Grid item xs={12} container>
                  <Grid item xs={12} md={12}>
                    <Next24HoursChart />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid> */}
          <Grid item xs={12} md={12}>
            <Card sx={{ margin: '20px 0' }}>
              <CardContent>
                {/* <Typography variant="h6">Next 24 Hours</Typography> */}
                <Grid item xs={12} container>
                  <Grid item xs={12} md={12}>
                    <TeamHoursChart />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {isSuperAdmin && (
            <Grid item xs={12} md={12}>
              <Card sx={{ margin: '20px 0' }}>
                <CardContent>
                  {/* <Typography variant="h6">Next 24 Hours</Typography> */}
                  <Grid item xs={12} container>
                    <Grid item xs={12} md={12}>
                      <UserIdleChart />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

          {/* <Grid item xs={12} md={12}>
            <Grid item xs={12} container gap={1}>
              <Grid item xs={12} md={5.5}>
                <Typography variant="body1" fontWeight={600}>
                  MODERATOR BEHIND SCHEDULE
                </Typography>
                <ModeratorScheduleTable apiData={hourChartData} />
              </Grid>
              <Grid item xs={12} md={5.5}>
                <Typography variant="body1" fontWeight={600}>
                  TAGGER BEHIND SCHEDULE
                </Typography>
                <TageerScheduleTable apiData={hourChartData} />
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </TabPanel>

      <TabPanel value={tabIndex} index={2}>
        <Card sx={{ margin: '20px 0' }}>
          <CardContent>
            <Games />
          </CardContent>
        </Card>
      </TabPanel>
    </Box>
  );
}

export default AdminDashboard;
